var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("SearchableDropdown", {
    staticClass: "m-b-10",
    class: _vm.customClass,
    attrs: {
      name: _vm.name,
      config: _vm.methodsDropdownConfig,
      clearable: false
    },
    model: {
      value: _vm.selectedMethod,
      callback: function($$v) {
        _vm.selectedMethod = $$v
      },
      expression: "selectedMethod"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }